import script from "./fileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./fileInput.vue?vue&type=script&setup=true&lang=js"

import "./fileInput.vue?vue&type=style&index=0&id=74fad677&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74fad677"]])

export default __exports__